import React from 'react';
import { Link } from 'react-router-dom';
import './css/NavBar.css';

import firebase from 'firebase';

class NavBar extends React.Component {
	state = {
		user: 'Log-in',
		currentUser: null,
	}
	componentDidMount() {
		let provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.setState({user: user.displayName, currentUser: user});
      }
    });
	}
	render() {
		let rightNav = "float: right;"
		// let customId = this.props.customId;
		console.log(this.state.currentUser);
		let photoURL = null;
		if(this.state.currentUser) {
			photoURL = this.state.currentUser.photoURL;
		}
		return(
		<div>
      		<div className="navbar fixed-top">
		          <nav className="textNav">
								<ul>
									<li><Link to="/home">Home</Link></li>
									<li><Link to="/hotels">Hotels</Link></li>
									<li><Link to="/about">About</Link></li>
									<li><Link to="/feedback">Feedback</Link></li>
									<div className="rightNav">
										<li><Link to="/profile">{this.state.user} <img src={photoURL} align="top"/></Link></li>
									</div>
								</ul>
							</nav>
		    	</div>
      		<div className="navbar fixed-top">
		          <nav className="iconNav">
								<ul>
									<li><Link to="/home"><i class="fa fa-home"></i></Link></li>
									<li><Link to="/hotels"><i class="fa fa-hotel"></i></Link></li>
									<li><Link to="/about"><i class="fa fa-info-circle"></i></Link></li>
									<li><Link to="/feedback"><i class="fa fa-comments"></i></Link></li>
									<div className="rightNav">
										<li><Link to="/profile"><img src={photoURL} align="top"/></Link></li>
									</div>
								</ul>
							</nav>
		    	</div>
		</div>
		)
	}
}

export default NavBar;
